<template>
  <div class="mb-5">
    <div class="mt-5 row">
      <div class="mx-auto col-lg-9 col-xs-12">
        <b-breadcrumb :items="items"></b-breadcrumb>
        <div class="card">
          <div class="card-header">Mensagem da Tela Inicial</div>
          <div class="card-body p-3">
            <div class="alert alert-success" v-if="sucesso">{{ sucesso }}</div>
            <div class="alert alert-danger" v-if="error">{{ error }}</div>

            <div class="row mb-3">
              <div class="col">
                <textarea id="mensagem-editor"></textarea>
              </div>
            </div>

            <div class="row pt-2">
              <div class="col">
                <div class="d-grid">
                  <button class="btn btn-success" @click="salvar" :disabled="salvando">
                    <span v-if="salvando">Salvando...</span>
                    <span v-else>Salvar</span>
                  </button>
                </div>
              </div>
              <div class="col">
                <div class="d-grid">
                  <button class="btn btn-secondary" @click="cancelar" :disabled="salvando">
                    Cancelar
                  </button>
                </div>
              </div>
            </div>

            <div class="row mt-4" v-if="conteudoAtual">
              <div class="col">
                <p class="font-weight-bold">Pré-visualização:</p>
                <div class="alert alert-warning" v-html="conteudoAtual"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      conteudoAtual: "",
      conteudoOriginal: "",
      salvando: false,
      error: null,
      sucesso: null,
      editor: null,
      items: [
        { text: "Admin", to: { name: "admin" } },
        { text: "Mensagem da Tela Inicial", active: true },
      ],
    };
  },
  computed: {
    http() {
      return this.$store.getters.http;
    },
  },
  methods: {
    inicializarEditor(conteudo) {
      const self = this;
      // eslint-disable-next-line no-undef
      tinymce.remove("#mensagem-editor");
      // eslint-disable-next-line no-undef
      tinymce.init({
        selector: "#mensagem-editor",
        language: "pt_BR",
        height: 400,
        branding: false,
        menubar: false,
        license_key: "gpl",
        plugins: [
          "advlist", "autolink", "lists", "link", "charmap", "preview", "anchor",
          "searchreplace", "visualblocks", "code", "fullscreen",
          "insertdatetime", "table", "wordcount",
        ],
        toolbar:
          "undo redo | bold italic | alignleft aligncenter alignright | table | code",
        content_style:
          "body { font-family: Arial, sans-serif; font-size: 14px; }",
        setup(ed) {
          self.editor = ed;
          ed.on("Change KeyUp", () => {
            self.conteudoAtual = ed.getContent();
          });
        },
        init_instance_callback(ed) {
          ed.setContent(conteudo);
          self.conteudoAtual = conteudo;
        },
      });
    },

    async buscar() {
      this.$Progress.start();
      try {
        const { data } = await this.http.get("/admin/mensagem-tela-inicial", {
          headers: { Authorization: `Bearer ${this.$store.getters.token}` },
        });
        const conteudo = data.data?.mensagem_tela_inicial || "";
        this.conteudoOriginal = conteudo;
        this.conteudoAtual = conteudo;
        this.inicializarEditor(conteudo);
        this.$Progress.finish();
      } catch (err) {
        this.error = err;
        this.$Progress.fail();
      }
    },

    async salvar() {
      this.error = null;
      this.sucesso = null;
      this.salvando = true;
      // eslint-disable-next-line no-undef
      const conteudo = tinymce.get("mensagem-editor")
        ? // eslint-disable-next-line no-undef
          tinymce.get("mensagem-editor").getContent()
        : this.conteudoAtual;
      this.$Progress.start();
      try {
        const { data } = await this.http.post(
          "/admin/mensagem-tela-inicial",
          { mensagem: conteudo },
          {
            headers: { Authorization: `Bearer ${this.$store.getters.token}` },
          }
        );
        if (data.success === false) {
          this.error = data.errors?.message || "Erro ao salvar.";
          this.$Progress.fail();
        } else {
          this.conteudoOriginal = conteudo;
          this.conteudoAtual = conteudo;
          this.sucesso = "Mensagem salva com sucesso!";
          this.$Progress.finish();
        }
      } catch (err) {
        this.error = err;
        this.$Progress.fail();
      } finally {
        this.salvando = false;
      }
    },

    cancelar() {
      this.error = null;
      this.sucesso = null;
      this.conteudoAtual = this.conteudoOriginal;
      this.inicializarEditor(this.conteudoOriginal);
    },
  },

  mounted() {
    this.buscar();
  },

  beforeDestroy() {
    // eslint-disable-next-line no-undef
    if (typeof tinymce !== "undefined") {
      // eslint-disable-next-line no-undef
      tinymce.remove("#mensagem-editor");
    }
  },
};
</script>

<style scoped>
.error {
  color: #dc3545;
  text-align: right;
}
</style>
